module.exports = __webpack_public_path__ + "fonts/iconfont.627b59bf.woff2";